// UIPreferences.js
import env from '../resource/env.js';

export const showAudio = true;

export const shouldShowPwaSafariToast = env.NODE_ENV === 'production';

export const shouldShowModal = env.NODE_ENV === 'production';
